import { render } from "./States.vue?vue&type=template&id=65a94fe2"
import script from "./States.vue?vue&type=script&lang=js"
export * from "./States.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__